import { isEmpty } from 'lodash';
import React from 'react';

const SchoolClinicOverview = ({ schoolClinicsDetails }) => {
  return (
    <div className="mt-4">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div>
                {schoolClinicsDetails?.schoolId && (
                  <p className="mb-2">
                    School ID: <strong>{schoolClinicsDetails?.schoolId}</strong>
                  </p>
                )}

                {schoolClinicsDetails?.healthcareFacilityId && (
                  <p className="mb-0">
                    Healthcare Facility ID: <strong>{schoolClinicsDetails?.healthcareFacilityId}</strong>
                  </p>
                )}

                {schoolClinicsDetails?.owner && (
                  <>
                    <p className="mb-2">
                      Owner ID: <strong>{schoolClinicsDetails?.owner?.id}</strong>
                    </p>
                    <p className="mb-2">
                      Owner Name: <strong>{schoolClinicsDetails?.owner?.displayName}</strong>
                    </p>
                    <p className="mb-2">
                      Owner Email: <strong>{schoolClinicsDetails?.owner?.email}</strong>
                    </p>
                    <p className="mb-2">
                      Owner Phone Number: <strong>{schoolClinicsDetails?.owner?.phoneNumber}</strong>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          {!isEmpty(schoolClinicsDetails?.emergencyContactInfo) && (
            <div className="card">
              <div className="card-body">
                <h5 className="border-bottom pb-3 mb-4">Emergency Contact Informations</h5>
                <div className="row">
                  {schoolClinicsDetails?.emergencyContactInfo?.map((contact) => (
                    <div className="col-md-4" key={contact?.name}>
                      <div className="card bg-light border">
                        <div className="card-body">
                          <div>
                            <p className="mb-2">
                              Type: <strong>{contact?.type}</strong>
                            </p>
                            <p className="mb-2">
                              Name: <strong>{contact?.name}</strong>
                            </p>
                            <p className="mb-2">
                              Phone number: <strong>{contact?.phoneNumber}</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SchoolClinicOverview;
